import React, { useState } from "react";
const emailUsername = process.env.REACT_APP_EMAIL_USERNAME;
const emailPassword = process.env.REACT_APP_EMAIL_PASSWORD;
const emailSecureToken = process.env.REACT_APP_SECURE_TOKEN;
const emailHost = process.env.REACT_APP_HOST;
const emailPort = process.env.REACT_APP_PORT;
const emailFrom = process.env.REACT_APP_FROM;
const emailTo = process.env.REACT_APP_TO;

const GetQuoteForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [successMessage, setSuccessMessage] = useState("");

  const [loading, setLoading] = useState(false);
  // const [successMessage, setSuccessMessage] = useState("");
  // const [submitting, setSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const config = {
        Username: emailUsername,
        Password: emailPassword,
        SecureToken: emailSecureToken,
        Host: emailHost,
        Port: emailPort,
        From: emailFrom,
        To: emailTo,
        Subject: "QUICK SEO WEBSITE - Get Quote Form",
        Body: `
        Hi,
        <br />
        <br />
        These are Get Quote Services Enquiry form details from Quick Seo Website.
        <br /> 
         <br />
         <strong>Name</strong> - ${formData.name} 
         <br/>
         <strong>Email</strong> - ${formData.email} 
         <br/>
         <strong>Subject</strong> - ${formData.subject} 
         <br/>
         <strong>Message</strong> - ${formData.message} 
         <br />
         <br />
         <br />
         Thank you
         <br />
         <br />
         <br />
        
               `,
      };

      if (window.Email) {
        await window.Email.send(config)
          .then((message) => console.log(message, "Message sent Successfully"))
          .catch((error) => {
            console.log(error);
          });
      }

      // Reset the form after successful submission
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
      // Handle success, show a success message, redirect, etc.
      setSuccessMessage("Message received! We will get back to you soon.");
    } catch (error) {
      console.error(
        "Error submitting form:",
        error.response ? error.response.data : error.message
      );
      // Handle error, show an error message, etc.
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div>
        {/* <div>{submitting && <p>Submitting...</p>}</div> */}
        <form action="" className="getQuote-form" onSubmit={handleSubmit}>
          <input
            name="name"
            type="text"
            value={formData.name}
            onChange={handleInputChange}
            id=""
            placeholder="Name"
            required
          />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            id=""
            placeholder="Email"
            required
          />
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleInputChange}
            id=""
            placeholder="Subject"
            required
          />
          <textarea
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            id=""
            cols="30"
            rows="10"
            placeholder="Message"
          ></textarea>
          <button type="submit" className="getQuote-btn" disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>
        </form>
        <div className="text-center">
          <center className="text-center py-3">
            {successMessage && <h6>{successMessage}</h6>}
          </center>
        </div>
      </div>
    </>
  );
};

export default GetQuoteForm;
